import React from 'react';
import { PercentAmount } from '@akropolis-web/primitives';

import { styled } from 'core/styles';

import type { FormattedAmountProps } from './types';

type Props<A extends PercentAmount> = Pick<
  FormattedAmountProps<A>,
  'withSI' | 'precision' | 'symbolSize' | 'hasSign' | 'renderSymbol'
> & {
  sum: A;
};

export function PercentAmountComponent<A extends PercentAmount>(props: Props<A>) {
  const { sum, withSI, precision, hasSign, symbolSize = 'small', renderSymbol } = props;

  return (
    <Root>
      {!sum.isNeg() && hasSign && '+'}
      {sum[withSI ? 'toShortString' : 'toFormattedString'](precision, false)}
      <Symbol size={symbolSize}>{renderSymbol ? renderSymbol(sum) : sum.currency.symbol}</Symbol>
    </Root>
  );
}

const Root = styled('span')(() => ({
  whiteSpace: 'nowrap',
}));

const Symbol = styled('span', { shouldForwardProp: prop => prop !== 'size' })<{
  size: NonNullable<FormattedAmountProps<PercentAmount>['symbolSize']>;
}>(({ size }) => ({
  ...{
    small: {
      fontSize: '0.5em',
      paddingLeft: '0.125em',
      verticalAlign: 'text-top',
      display: 'inline-block',
      marginTop: 2,
    },
    medium: {
      fontSize: '0.7em',
      paddingLeft: '0.28em',
      verticalAlign: 'text-top',
      display: 'inline-block',
      marginTop: 2,
    },
    inherit: {},
  }[size],
}));
